import React from "react";
import classNames from "classnames";
import { SectionTilesProps } from "../../../utils/SectionProps";
import SectionHeader from "../partials/SectionHeader";
import { teamMembers } from "../../../data/team";

const propTypes = {
  ...SectionTilesProps.types,
};

const defaultProps = {
  ...SectionTilesProps.defaults,
};

const WhoWeAre = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  invertMobile,
  invertDesktop,
  alignTop,
  ...props
}) => {
  const outerClasses = classNames(
    "testimonial section",
    topOuterDivider && "has-top-divider",
    bottomOuterDivider && "has-bottom-divider",
    hasBgColor && "has-bg-color",
    invertColor && "invert-color",
    className
  );

  const innerClasses = classNames(
    "testimonial-inner section-inner-whoweare",
    topDivider && "has-top-divider",
    bottomDivider && "has-bottom-divider"
  );

  const tilesClasses = classNames("tiles-wrap center-content");

  const sectionHeader = {
    title: "Who",
    title_highlight: "We Are",
  };

  const sorted = [...teamMembers].sort((a, b) => a.order - b.order);

  return (
    <section {...props} className={outerClasses}>
      <div className="container">
        <div className={innerClasses}>
          <SectionHeader data={sectionHeader} className="center-content pb-0" />
          <div className={tilesClasses}>
            <p
              className="text-xs text-center mb-48 px-3 reveal-from-top"
              data-reveal-delay="200"
            >
              Trade Square is a limited company registered in Thailand in 2015.
              <br />
              We are specialized in Cloud Solution and customized software and
              platform development.
            </p>

            {sorted.map((member, index) => {
              const isFirst = index === 0;
              // First member: photo on right for md+, photo on left for sm-
              // Subsequent members: photo always on left
              return (
                <React.Fragment key={member.id}>
                  {isFirst ? (
                    <>
                      {/* Desktop layout: text left, photo right */}
                      <div className="row-content show-content-md-up mb-48">
                        <div
                          className="tiles-item-whoweare-top-left reveal-from-left"
                          data-reveal-delay="200"
                        >
                          <p className="text-xs my-0">"{member.quote}"</p>
                          <p className="text-xs my-0 pt-3">
                            - {member.name}
                            <br />
                            {member.title}
                          </p>
                        </div>
                        <div
                          className="tiles-item-whoweare-top-right reveal-from-left"
                          data-reveal-delay="200"
                        >
                          <div className="d-flex flex-column align-items-center justify-content-center">
                            <div className="h-content-for-w-img-300px">
                              <img
                                src={member.photo}
                                alt={member.name}
                                className="w-img-300px img-has-shadow"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Mobile layout: photo top, text below */}
                      <div className="row-content show-content-sm-down mb-48">
                        <div
                          className="tiles-item-whoweare-bottom-left reveal-from-right"
                          data-reveal-delay="200"
                        >
                          <div className="d-flex flex-column align-items-center justify-content-center">
                            <div className="h-content-for-w-img-300px">
                              <img
                                src={member.photo}
                                alt={member.name}
                                className="w-img-300px img-has-shadow"
                              />
                            </div>
                          </div>
                        </div>
                        <div
                          className="tiles-item-whoweare-bottom-right reveal-from-right"
                          data-reveal-delay="200"
                        >
                          <p className="text-xs my-0">"{member.quote}"</p>
                          <p className="text-xs my-0 pt-3">
                            - {member.name}
                            <br />
                            {member.title}
                          </p>
                        </div>
                      </div>
                    </>
                  ) : (
                    <div className="row-content">
                      <div
                        className="tiles-item-whoweare-bottom-left reveal-from-right"
                        data-reveal-delay="200"
                      >
                        <div className="d-flex flex-column align-items-center justify-content-center">
                          <div className="h-content-for-w-img-300px">
                            <img
                              src={member.photo}
                              alt={member.name}
                              className="w-img-300px img-has-shadow"
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        className="tiles-item-whoweare-bottom-right reveal-from-right"
                        data-reveal-delay="200"
                      >
                        <p className="text-xs my-0">"{member.quote}"</p>
                        <p className="text-xs my-0 pt-3">
                          - {member.name}
                          <br />
                          {member.title}
                        </p>
                      </div>
                    </div>
                  )}
                </React.Fragment>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

WhoWeAre.propTypes = propTypes;
WhoWeAre.defaultProps = defaultProps;

export default WhoWeAre;
